import { LoadingSpinner } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { DocumentDetailsSection } from "../../../Details/DetailsSection";
import { INFO_DESCRIPTION } from "../constants";

interface InfoStepProps {
  isLoading?: boolean;
}

export function InfoStep({ isLoading = false }: InfoStepProps) {
  if (isLoading) {
    return (
      <Stack spacing={3} alignItems="center" justifyContent="center" height="100%" width="100%">
        <LoadingSpinner size="large" />
      </Stack>
    );
  }

  return <DocumentDetailsSection title="" description={INFO_DESCRIPTION} />;
}
